import { createAsyncThunk } from "@reduxjs/toolkit";
import { GAService } from "../../../services";

export const changeGridType = createAsyncThunk("header/changeGridType", (type) => {
  localStorage.setItem("gridType", type);
  GAService.sendEvent("gridType", type);
  return type;
});
